import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

interface ISubmitButtonProps {
  submitting: boolean;
  disabled: boolean;
  onClick: () => void;
}

export default function SubmitButton(props: ISubmitButtonProps) {
  const { submitting, disabled, onClick } = props;

  return (
    <Button
      variant="contained"
      endIcon={submitting && <CircularProgress color="inherit" size={24} sx={{ ml: 1 }} />}
      disabled={disabled}
      onClick={onClick}
    >
      {submitting ? 'Submitting' : 'Submit Feedback'}
    </Button>
  );
}
